import Api from 'utils/ApiRequest';
import API_URL from 'constants/api';
import { actionSet } from './utils';
import { getPages } from 'component/pagination/utils';
import { USE_CONSUME_ERROR, USE_CONSUME_SUCCESS, } from 'actionTypes';
import { hideSpinner, showSpinner } from './spinner';
import { PriceAuditType } from 'utils/Enums';
import moment from 'moment';
export var priceAuditTypeFromStatusCode = function (statusCode) { return PriceAuditType[statusCode - 1]; };
export var fetchUseConsumeReport = function (token, param, callback, signalController) { return function (dispatch) {
    param.dtStart = "".concat(moment(param.dtStart).format('YYYY-MM-DD'), "T00:00:00.000Z");
    param.dtEnd = "".concat(moment(param.dtEnd).format('YYYY-MM-DD'), "T23:59:59.999Z");
    param.lms = param.dsLdaps || [];
    var onClose = function () {
        dispatch(hideSpinner());
        dispatch(hideSpinner());
    };
    var onError = function (error) {
        dispatch(actionSet(USE_CONSUME_ERROR, error));
        onClose();
    };
    var onMessage = function (response) {
        dispatch(getPages(response.data.pages));
        dispatch(actionSet(USE_CONSUME_SUCCESS, response.data.reportList));
        if (callback) {
            callback(response.data.reportList, response.data.pages.totalCount);
        }
        onClose();
    };
    var abort = function () {
        signalController.abort();
        dispatch(hideSpinner());
        dispatch(hideSpinner());
    };
    dispatch(showSpinner("", true, abort));
    return new Api(token, dispatch)
        .eventSourceStream(API_URL.USE_COSUME_V2_REPORT, param, null, signalController, onMessage, onClose, onError)
        .catch(function (error) { return onError(error); });
}; };
